var React = require('react');

function Map (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":" M 76.875 11.25 L 76.275 11.362 L 56.25 19.125 L 33.75 11.25 L 12.6 18.375 C 11.813 18.638 11.25 19.313 11.25 20.175 L 11.25 76.875 C 11.25 77.925 12.075 78.75 13.125 78.75 L 13.725 78.637 L 33.75 70.875 L 56.25 78.75 L 77.4 71.625 C 78.188 71.363 78.75 70.688 78.75 69.825 L 78.75 13.125 C 78.75 12.075 77.925 11.25 76.875 11.25 Z  M 56.25 71.25 L 33.75 63.338 L 33.75 18.75 L 56.25 26.662 L 56.25 71.25 Z ","key":0}),React.createElement("path",{"d":" M 0 0 L 90 0 L 90 90 L 0 90 L 0 0 Z ","fill":"none","key":1})]));
}

Map.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"0 0 90 90","width":"90pt","height":"90pt"};

module.exports = Map;

Map.default = Map;
